<script setup>
import {inject, onBeforeMount, ref} from 'vue';
import {useRoute, useRouter} from "vue-router/composables";
import Steps from '../Steps.vue';
import Applicants from '../common/Applicants.vue';
import Calculator from './Calculator.vue';
import Equipment from '../common/Equipment.vue';
import Save from '../common/Save.vue';

const application = ref({});
const canRender = ref(false);
const context = inject("applicationContext");
const route = useRoute();
const router = useRouter();

const stepsRequired = ref(["applicants", "calculator", "equipment", "save"]);
const components = {
	"leaseApplicants": Applicants,
	"leaseCalculator": Calculator,
	"leaseEquipment": Equipment,
	"leaseSave": Save
}

onBeforeMount(async () => {
	canRender.value = false;
	application.value = context.application.value;
	if ((route.params.applicationId || "new") === "new") {
		if (route.name !== "leaseCalculator") {
			await router.push({
				name: "leaseCalculator",
				params: {applicationId: "new"}
			});
		}
	} else {
		if (!application.value || application.value.application.id !== route.params.applicationId) {
			try {
				application.value = await context.getApplication(route.params.applicationId);
			} catch (error) {
				await router.push({ name: "Dashboard" });
			}
		}
		if (!application.value?.application?.firstName) {
			if (!["leaseCalculator", "leaseApplicants"].includes(route.name)) {
				await router.push({
					name: "leaseApplicants",
					params: {applicationId: route.params.applicationId}
				});
			}
		}
		const isLease = application.value?.application?.program?.program?.Code === "2";
		if (!isLease) {
			const newRouteName = route.name.replace("lease", "loan");
			await router.push({
				name: newRouteName,
				params: {
					applicationId: application.value?.application?.id,
				}
			});
		}
	}
	canRender.value = true;
});

</script>

<template>
	<div class="payment-calculator-template">
		<Steps :allowedSteps="stepsRequired" :application="application" :component="components[route.name]" type="lease" v-if="canRender" />
	</div>
</template>
